var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-login" }, [
    _c("div", { staticClass: "page-login--layer page-login--layer-area" }, [
      _c(
        "ul",
        { staticClass: "circles" },
        _vm._l(10, function (n) {
          return _c("li", { key: n })
        }),
        0
      ),
    ]),
    _c(
      "div",
      {
        staticClass: "page-login--layer page-login--layer-time",
        attrs: { flex: "main:center cross:center" },
      },
      [_vm._v(" " + _vm._s(_vm.time) + " ")]
    ),
    _c("div", { staticClass: "page-login--layer" }, [
      _c(
        "div",
        {
          staticClass: "page-login--content",
          attrs: { flex: "dir:top main:justify cross:stretch box:justify" },
        },
        [
          _vm._m(0),
          _c(
            "div",
            {
              staticClass: "page-login--content-main",
              attrs: { flex: "dir:top main:center cross:center" },
            },
            [
              _c("img", {
                staticClass: "page-login--logo",
                attrs: { src: require("./image/logo@2x.png") },
              }),
              _c(
                "div",
                { staticClass: "page-login--form" },
                [
                  _c(
                    "el-card",
                    { attrs: { shadow: "never" } },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "loginForm",
                          attrs: {
                            "label-position": "top",
                            rules: _vm.rules,
                            model: _vm.formLogin,
                            size: "default",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "username" } },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    type: "text",
                                    placeholder: "用户名/手机号",
                                  },
                                  model: {
                                    value: _vm.formLogin.username,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formLogin, "username", $$v)
                                    },
                                    expression: "formLogin.username",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-user",
                                    attrs: { slot: "prepend" },
                                    slot: "prepend",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "password" } },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    type: "password",
                                    placeholder: "密码",
                                  },
                                  model: {
                                    value: _vm.formLogin.password,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formLogin, "password", $$v)
                                    },
                                    expression: "formLogin.password",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-lock",
                                    attrs: { slot: "prepend" },
                                    slot: "prepend",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("el-form-item", { attrs: { prop: "captcha" } }, [
                            _c("div", {
                              staticClass: "nc-container",
                              attrs: { id: "captcha" },
                            }),
                          ]),
                          _c(
                            "el-button",
                            {
                              staticClass: "button-login",
                              attrs: { size: "default", type: "primary" },
                              on: { click: _vm.submit },
                            },
                            [_vm._v(" 登录 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("p", {
                    staticClass: "page-login--options",
                    attrs: { flex: "main:justify cross:center" },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._m(1),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-login--content-header" }, [
      _c("p", { staticClass: "page-login--content-header-motto" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-login--content-footer" }, [
      _c("p", { staticClass: "page-login--content-footer-copyright" }, [
        _vm._v(
          " 版权所有© 2017-2020 上海丞诺网络科技有限公司 沪ICP备17007891号-1 "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }